import { createReducer } from '@reduxjs/toolkit';
import { getBookingStatus, getIntentSecret, getInvoiceById, getTransactionsPdf, paymentResetValue, upgradePackage } from '../actions';
import { IBookingStatus } from '../models';
import { IPaymentPackages } from '../models/PaymentModels';

export interface IPaymentInitialState {
  clientSecret: '';
  bookingStatus: IBookingStatus
  transactionsPdf: {
    pdfContent: string
  }
  upgradeResult: {
    success: boolean,
    secret: string
  },
  paymentPackages: IPaymentPackages;
  invoicePdf: {
    pdfContent: string;
  }
}

export const paymentInitialState: IPaymentInitialState = {
  invoicePdf: {
    pdfContent: '',
  },
  clientSecret: '',
  paymentPackages: [],
  transactionsPdf: {
    pdfContent: ''
  },
  bookingStatus: {
    bookingId: '',
    status: 0,
    type: 1,
    paymentStatus: 3,
    approved: false
  },
  upgradeResult: {
    success: false,
    secret: ''
  }
};

const paymentReducer = createReducer(paymentInitialState, (builder) => {
  builder
    .addCase(getIntentSecret.fulfilled, (state, action) => {
      state.clientSecret = action.payload;
    })
    .addCase(upgradePackage.fulfilled, (state, action) => {
      state.upgradeResult = action.payload
    })
    .addCase(getBookingStatus.fulfilled, (state, action) => {
      state.bookingStatus = action.payload
    })
    .addCase(getTransactionsPdf.fulfilled, (state, action) => {
      state.transactionsPdf = action.payload
    })
    .addCase(getInvoiceById.fulfilled, (state, action) => {
      state.invoicePdf = action.payload
    })
    .addCase(paymentResetValue, (state, action) => {
      action.payload.map(
        (item) => {
          // @ts-expect-error: REDUCERS HAVE WRITABLE INNATE TYPE
          state[item] =
            paymentInitialState[item as keyof typeof paymentInitialState]
        }
      )
    })
    ;
});

export default paymentReducer;